import { Controller } from "@hotwired/stimulus";

// Reveals the single targeted follow-up question for the selected cancellation
// reason and disables the other follow-up fields so only one answer submits.
export default class extends Controller {
  static targets = ["followUp"];

  connect() {
    this.update();
  }

  update() {
    const checked = this.element.querySelector("input[name='cancellation_feedback[reason]']:checked");
    const reason = checked ? checked.value : null;

    this.followUpTargets.forEach((block) => {
      const matches = reason !== null && block.dataset.cancellationSurveyReason === reason;
      block.hidden = !matches;

      block.querySelectorAll("input, select, textarea").forEach((field) => {
        field.disabled = !matches;
      });
    });
  }
}
